const DEFAULT_EXPIRATION_DAYS = 180;

const getCookieExpirationDate = (expirationDate: number) => {
  const date = new Date();
  date.setDate(date.getDate() + expirationDate);
  return date;
};

export const setCookie = (key: string, value: string, daysUntilExpiration: number = DEFAULT_EXPIRATION_DAYS) => {
  // We want to set the Secure attribute for cookies in all environments except for
  // development -- Secure prevents us from sending the cookie over non-HTTPS channels.
  //
  // In development, we don't use HTTPS so we can't set the cookie with that attribute.
  const inDevEnv = process.env.NODE_ENV === 'development';
  const secureAttrib = inDevEnv ? '' : '; secure';

  /**
   * Safari ignores expiry for cookies. For both cookies and local storage, Safari allows a rolling 7 days of life.
   * If accessed within 7 days, the clock resets and the item remains valid. If not, it's removed.
   */
  const expirationDate = getCookieExpirationDate(daysUntilExpiration);
  document.cookie = `${key}=${value}; expires=${expirationDate}; samesite=strict; path=/${secureAttrib}`;
};

export const getCookie = (key: string): string | null => {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find(c => c.startsWith(key));

  if (cookie) {
    const [, value] = cookie.split('=');
    return value;
  }

  return null;
};

export const clearCookie = (key: string) => {
  // Delete cookie by setting it to an empty value, with an expiration date from the past.
  const inDevEnv = process.env.NODE_ENV === 'development';
  const secureAttrib = inDevEnv ? '' : '; secure';
  document.cookie = `${key}=; path=/${secureAttrib}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
